import React, { Component, Fragment } from 'react';

import { showUserAction } from 'store/modules/profileDetails/actions';
import {
  updatePaymentAndSubscribe,
  updateTrialAndSubscribe,
} from 'store/modules/content/actions';
import { HeaderLoggedIn } from 'scenes/Header';
import connect from 'react-redux/es/connect/connect';
import BillingForm from 'components/BillingForm';

import buildPrice from 'helpers/buildPrice';
import AlertMessage from 'components/AlertMessage';
import BillingModal from 'components/BillingForm/BillingModal';

import { faLastfm } from '@fortawesome/free-brands-svg-icons';

import ReactPixel from 'react-facebook-pixel';

class Billing extends Component {
  state = {
    showAlert: false,
    alertText: '',
    accounts: 1,
    plan: 'monthly',
    billingMounted: false,
  };
  static propTypes = {};

  async componentDidMount() {
    const { showUserAction, user} = this.props;
    showUserAction();
    if (
      localStorage.getItem('expected_accounts') &&
      localStorage.getItem('expected_plan')
    ) {
      this.setState({
        accounts: parseInt(localStorage.getItem('expected_accounts')),
        plan: localStorage.getItem('expected_plan'),
      });
    }

    ReactPixel.track('InitiateCheckout');
    ReactPixel.track('AddPaymentInfo');
  }

  updatePaymentAndSubscription = async (values, setSubmitting, setErrors) => {
    const { updatePaymentAndSubscribe, updateTrialAndSubscribe } = this.props;
    const { accounts, plan } = this.state;
    const trialToken = localStorage.getItem('trialToken');
    const body = {
      card: {
        number: values.ccnumber.toString().replace(/\ /g, ''),
        exp_month: values.exp_month.toString(),
        exp_year: (2000 + parseInt(values.exp_year)).toString(),
        cvc: values.cvv2.toString().replace(/\ /g, ''),
        name: values.first_name + ' ' + values.last_name,
        address_country: values.country,
        address_line1: values.address,
        address_zip: values.zip,
      },
      subscription: {
        plan: values.plan.toString(),
        expected_accounts: accounts,
        expected_plan: plan,
        coupon: values.coupon,
        trial_token: trialToken,
      },
    };
    const response = await updatePaymentAndSubscribe(
      body,
      setSubmitting,
      setErrors,
    );

    if (response.status === 201 || response.status === 200) {
      localStorage.removeItem('trialToken');
      this.props.history.push('/thanks');
    } else {
      this.setState({ showAlert: true });
      this.setState({ alertText: response.error.message || response.error });
      setTimeout(() => {
        this.setState({ showAlert: false });
      }, 4000);
    }
  };

  changePlan = value => {
    this.setState({
      plan: value,
    });
  };

  handleAccounts = value => {
    this.setState({
      accounts: value,
    });
  };

  handleBillingDetails = ({ values, setSubmitting, setErrors }) => {};

  get_location_source_from = () => {
    if (this.props.location.from) {
      return this.props.location.from
    } else {
      return {source: 'not from upgrade button'}
    }
  }

  render() {
    const {
      showAlert,
      alertText,
      showAlertSuccess,
      alertTextSuccess,
      plan,
      accounts,
    } = this.state;
    const { details, user, location } = this.props;
    return (
      <Fragment>
        <HeaderLoggedIn />
        {showAlert && <AlertMessage classAlert="error" text={alertText} />}
        <div className="profile container billing-container">
          <div className="billing__top">
            <div className="billing-title">Checkout</div>
            <div className="text">
              You’ve selected the InstaLinks Pro with&nbsp;
              {plan === 'monthly' && (
                <strong>
                  {accounts} domain <br /> billed Monthly for ${' '}
                  {buildPrice(accounts, plan)} per month.
                </strong>
              )}
              {plan === 'annually' && (
                <strong>
                  {accounts} domain <br /> billed Annually for ${' '}
                  {buildPrice(accounts, plan)} per year.
                </strong>
              )}
              &nbsp;
              <BillingModal
                period={plan}
                trial={details.trial}
                accounts={accounts}
                changePlan={this.changePlan}
                changeAccounts={this.handleAccounts}
                handleSubmit={this.handleBillingDetails}
                handleAccounts={this.handleChangeAccounts}
              />
            </div>
          </div>
          <BillingForm
            handleSubmit={this.updatePaymentAndSubscription}
            cost={buildPrice(accounts, plan)}
            coupon={user.coupon_id}
            source_from={this.get_location_source_from()}
          />
          <div className="copyright">
            © Copyright {new Date().getFullYear()} InstaLinks. All rights reserved.
          </div>
        </div>
        {/*<Footer />*/}
      </Fragment>
    );
  }
}

function mapStateProps(state) {
  return {
    details: state.details.user,
  };
}

const mapDispatchToProps = {
  showUserAction,
  updatePaymentAndSubscribe,
  updateTrialAndSubscribe,
};

export default connect(
  mapStateProps,
  mapDispatchToProps,
)(Billing);



// WEBPACK FOOTER //
// ./src/scenes/Billing/Billing.js